import { useDispatch, useSelector } from 'react-redux';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { AppDispatch, RootState } from '../../../../store';
import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import JourneyAction from '../../JourneyAction';
import CircleIcon from '../../CircleIcon';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import Button from '@mui/material/Button';
import { Button as ButtonSmall } from '../style';
import { EScheduleSteps, initizalizeScheduleAppointment } from '../../../../features/schedule/schedule-slice';
import { initialState as journeyInitialState, saveCurrentJourney } from '../../../../features/journey';
import { EnumJourneyAction, getJourneyAction } from '../../../../utils/enum/journeyAction';
import { dynamicCustomEventTracking } from '../../../../lib/gtm';
import { chooseCalendar, ChooseCalendarResult, EScheduleType } from '../../../../features/calendar/calendar-slice';
import { IJourneyResp, ISchedules } from '../../../../services/journey.service';

export const AwaitingScheduleSmall = ({ journey }: JourneyActionPayload) => {
  const {
    schedule: { confirm },
    calendar: { calendarsAvailables, journey: calendarJourney }
  } = useSelector((state: RootState) => state);
  const dispatch: AppDispatch = useDispatch();
  const currentSchedule = getCurrentSchedule(journey);
  const status = getJourneyAction(journey || journeyInitialState);

  const handleAction = (journey: IJourneyResp) => {
    dispatch(chooseCalendar({ journey, schedule: currentSchedule, scheduleType: EScheduleType.DEFAULT })).then(res => {
      const payload = res.payload as ChooseCalendarResult;
      if (!payload) return;

      dispatch(initizalizeScheduleAppointment({ currentStep: EScheduleSteps.openCalendar }));
      dynamicCustomEventTracking.send({
        dynamicEventName: `agendar_jornada_mc`
      });
    });
  };

  return (
    <>
      <JourneyWithNextSchedule
        journey={journey}
        schedule={currentSchedule as ISchedules}
        actionButton={
          confirm &&
          status !== EnumJourneyAction.AWAITING_SCHEDULE &&
          status !== EnumJourneyAction.AWAITING_SCHEDULE_RETURN ? (
            <> </>
          ) : (
            <ButtonSmall variant="contained" onClick={() => handleAction(journey)}>
              Agendar agora
            </ButtonSmall>
          )
        }
      />
    </>
  );
};

export const AwaitingScheduleLarge = ({ journey }: JourneyActionPayload) => {
  const {
    schedule: { confirm }
  } = useSelector((state: RootState) => state);
  const dispatch: AppDispatch = useDispatch();
  const currentSchedule = getCurrentSchedule(journey);

  const handleAction = (journey: IJourneyResp) => {
    dispatch(saveCurrentJourney(journey));
    dispatch(chooseCalendar({ journey, schedule: currentSchedule, scheduleType: EScheduleType.DEFAULT })).then(res => {
      const payload = res.payload as ChooseCalendarResult;
      if (!payload) return;

      dispatch(initizalizeScheduleAppointment({ currentStep: EScheduleSteps.openCalendar }));
      dynamicCustomEventTracking.send({
        dynamicEventName: `agendar_jornada_mc`
      });
    });
  };

  if (confirm) return <></>;

  return (
    <JourneyAction
      icon={<CircleIcon border size="60px" icon={<WarningAmberIcon />} />}
      title="Agende sua consulta"
      subtitle={`Seu exame está pronto, agora você só precisa escolher o melhor horário pra sua consulta com ginecologista especialista em fertilidade`}
    >
      <Button variant="contained" color="primary" onClick={() => handleAction(journey)}>
        Agendar agora
      </Button>
    </JourneyAction>
  );
};
